import { Component, OnInit } from '@angular/core';
import { ToasterServiceService } from '../../service/toaster.service';
import { MatDialog } from '@angular/material/dialog';
import { Location } from '@angular/common';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmDialog } from '../../shared/confirm-dialog.component';
import { LocalStorageService } from '../../service/local-storage.service';

@Component({
  selector: 'app-invitaion-presentm-memebr',
  templateUrl: './invitaion-presentm-memebr.component.html',
  styleUrl: './invitaion-presentm-memebr.component.scss'
})
export class InvitaionPresentmMemebrComponent implements OnInit {
  getInvitedMemberListMain: any;
  getInvitedMemberList: any
  subEventId: any;
  getPresentMemberMain: any;
  getPresentMember: any
  userTypeId: any;
  user_id: any;
  selectedTabIndex: number = 0;
  dateFlag: any = false;
  constructor(
    private toasterService: ToasterServiceService,
    private dialog: MatDialog,
    private location: Location,
    private route: ActivatedRoute,
    private mainService: MainService,
    private router: Router,
    private localStorageService: LocalStorageService) {
    this.userTypeId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_type_id;
    this.user_id = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
    this.route.params.subscribe((params: any) => {
      this.subEventId = params['sub_event_id'] || '';
      this.dateFlag = params['flag'] || '';
    });

  }

  ngOnInit() {
    this.selectedTabIndex == 0 ? this.getSubEventInvitedMemberList() : this.getSubEventPresentMember();
  }

  goBackToPrevPage() {
    this.location.back();
  }

  onTabChanged(event: number) {
    this.selectedTabIndex == 0 ? this.getSubEventInvitedMemberList() : this.getSubEventPresentMember();
  }
  
  allMemberData: any;
  getSubEventInvitedMemberList() {
    this.mainService.getApi(ApiUrls.getSubEventInvitedMember + this.subEventId).subscribe(res => {
      if (res.status == 1) {
        this.allMemberData = res.sub_event_member.map((item: any) => ({
          ...item,
          is_active: +item.is_active
        }));
        if (this.userTypeId == 1) {
          this.getInvitedMemberListMain = this.allMemberData;
          this.getInvitedMemberList = this.allMemberData
        } else {
          this.getInvitedMemberListMain = this.allMemberData.filter((x: any) => x.user_id == this.user_id && x.is_active == 1);
          this.getInvitedMemberList = this.allMemberData.filter((x: any) => x.user_id == this.user_id && x.is_active == 1);
        }
      }
    })
  }

  getSubEventPresentMember() {
    this.getPresentMember = [];
    var data: any = {
      event_attendance_id: Number(this.subEventId),
      created_by: 0,
      attendance_time: '',
      sub_event_id: Number(this.subEventId),
      sub_event_member_id: 0,
      Action: 'SELECT'
    }
    this.mainService.putApi(ApiUrls.attendanceMemberCrud, data, 1).subscribe(res => {
      if (res.status == 1) {
        this.toasterService.toastSuccess(res.response);
        this.getPresentMember = res.event_attendance
      } else {
        this.toasterService.toastError(res.response);
      }
    })
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.getSubEventInvitedMemberList();
      this.getSubEventPresentMember();
      return;
    }
    if (this.selectedTabIndex == 0) {
      this.getInvitedMemberList = this.getInvitedMemberListMain.filter((data: any) => {
        return data.member_name.toLowerCase().includes(filterValue)
      });
    } else {
      this.getPresentMember = this.getPresentMemberMain.filter((data: any) => {
        return data.member_name.toLowerCase().includes(filterValue)
      });
    }
  }

  goToSendInvitation() {
    if (this.dateFlag != 'true') {
      this.router.navigate(["/send-invitation/" + this.subEventId]);
    } else {
      this.toasterService.toastError('આ કાર્યક્રમ સમાપ્ત થઈ ગયો છે')
    }
  }

  showQr(id: any) {
    if (this.dateFlag != 'true') {
      const dialogRef = this.dialog.open(ConfirmDialog, {
        data: {
          page: 'showQr',
          sub_event_member_id: id
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result == 1) {

        }
      });
    } else {
      this.toasterService.toastError('આ કાર્યક્રમ સમાપ્ત થઈ ગયો છે')
    }
  }

  openDialog(e: any, data: any): void {
    const dialogRef = this.dialog.open(ConfirmDialog, {
      data: {
        page: 'JobList'
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        this.deleteInvitedMember(data);
      } else {
        e.source.checked = !e.checked;
        data.status = e.checked == true ? 0 : 1;
      }
    });
  }

  deleteInvitedMember(data: any) {
    var obj: any = {
      sub_event_member_id: Number(data.sub_event_member_id),
      sub_event_id: 0,
      user_ids_json: '[]',
      created_by: 0,
      Action: 'STATUS'
    }
    this.mainService.postApi(ApiUrls.sendInvitationToMember, obj, 1).subscribe(res => {
      if (res.status == 1) {
        this.toasterService.toastSuccess(res.response);
        this.getSubEventInvitedMemberList();
      } else {
        this.toasterService.toastError(res.response);
      }
    })
  }
}
